// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";

export function hasAdditionalParamChanges(state: ApplicationState) {
    const greifSate = state.greif;
    const accountAdditionalSettings = greifSate.pages.accountSettings;
    const account = getCurrentAccountState(state).value;
    const accountProp = JSON.parse(account?.properties?.notificationsFollowed || "{}");
    const accountLanguage = account?.properties?.communicationLanguageId;

    if (!accountAdditionalSettings || !account || !accountProp) {
        return false;
    }

    return (
        accountProp?.followNewPrice !== accountAdditionalSettings?.followNewPrice ||
        accountProp?.followNewFeature !== accountAdditionalSettings?.followNewFeature ||
        accountProp?.followNewTec !== accountAdditionalSettings?.followNewTec ||
        accountProp?.followUpcomingShipment !== accountAdditionalSettings?.followUpcomingShipment ||
        accountProp?.followOrderShipped !== accountAdditionalSettings?.followOrderShipped ||
        accountProp?.followOrderPickup !== accountAdditionalSettings?.followOrderPickup ||
        accountLanguage !== accountAdditionalSettings.language
    );
}
